document.addEventListener('DOMContentLoaded', function() {
  var accordionTitles = document.querySelectorAll('.accordion-title');

  accordionTitles.forEach(function(title) {
    title.addEventListener('click', function() {
      var parentItem = this.parentElement;
      var details = parentItem.querySelector('.accordion-details');

      // Close other open items
      document.querySelectorAll('.accordion-item').forEach(function(item) {
        if (item !== parentItem) {
          item.classList.remove('active');
          item.querySelector('.accordion-details').style.maxHeight = null;
        }
      });

      // Toggle current accordion item
      if (parentItem.classList.contains('active')) {
        parentItem.classList.remove('active');
        details.style.maxHeight = null; // Collapse
      } else {
        parentItem.classList.add('active');
        details.style.maxHeight = details.scrollHeight + 'px'; // Expand to full height
      }
    });
  });
});
